export const NEXT_DEFAULT_LOCALE = "en" as const;

export function getLocalePrefix(
  locale: string | undefined,
  defaultLocale: string = NEXT_DEFAULT_LOCALE,
): string {
  const resolvedLocale = locale ?? defaultLocale;
  return resolvedLocale !== defaultLocale ? `/${resolvedLocale}` : "";
}
